import { Chip, Text, Tooltip } from '@truepill/react-capsule'
import { PrescriptionOrigin } from '@truepill/tpos-types'
import type { CSSObject } from 'styled-components'
import {
  capsuleErrorDark,
  capsuleGrey300Color,
  capsuleTypographyDark,
  capsuleTypographyWhite,
} from 'styles/styleVariables'

type IntakeMethodChipProps = {
  origin: string
  isDirectTransfer?: boolean
  css?: CSSObject
}

enum TooltipText {
  ELECTRONIC = 'Data sourced from customer',
  MANUAL = 'Data sourced from manual input',
  UNKNOWN = 'Data source is unknown',
}

const IntakeMethodChip = ({ origin, isDirectTransfer, css }: IntakeMethodChipProps): JSX.Element => {
  let displayText = origin,
    textColor = capsuleTypographyDark,
    backgroundColor = capsuleGrey300Color

  if (origin === PrescriptionOrigin.TELEPHONE) {
    displayText = 'verbal'
  } else if (origin === PrescriptionOrigin.WRITTEN || origin === PrescriptionOrigin.FAX) {
    textColor = capsuleTypographyWhite
    backgroundColor = capsuleErrorDark
  } else if (origin === PrescriptionOrigin.PHARMACY) {
    if (isDirectTransfer) {
      displayText = 'direct transfer'
    } else {
      displayText = 'transfer'
    }
  }

  let tooltipLabel = TooltipText.ELECTRONIC
  if (
    origin === PrescriptionOrigin.FAX ||
    origin === PrescriptionOrigin.TELEPHONE ||
    origin === PrescriptionOrigin.WRITTEN
  ) {
    tooltipLabel = TooltipText.MANUAL
  } else if (origin === PrescriptionOrigin.UNKNOWN) {
    tooltipLabel = TooltipText.UNKNOWN
  }

  return (
    <Tooltip variant="white" label={tooltipLabel} css={{ zIndex: '999' }}>
      <Chip
        css={{
          paddingBottom: '0.25rem',
          height: '1.75rem',
          color: textColor,
          backgroundColor: backgroundColor,
          ...css,
        }}
      >
        <Text variant="chip">{displayText}</Text>
      </Chip>
    </Tooltip>
  )
}

export default IntakeMethodChip
